export function getJwtPayload(token) {
  if (!token) return null;

  try {
    const payloadBase64 = token.split('.')[1];
    const normalized = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(normalized);
    return JSON.parse(json);
  } catch {
    return null;
  }
}
const token = localStorage.getItem('token');
const payload = getJwtPayload(token);
const isAdmin = payload?.role === 'admin';
